import PropTypes from 'prop-types';
import { useCallback } from 'react';

import Formsy from 'formsy-react';

import { useAppAlert } from '@Components/AppAlert';

const propTypes = {
  disabled: PropTypes.bool,
  getModel: PropTypes.func,
  mapping: PropTypes.func,
  onChange: PropTypes.func,
  onInvalid: PropTypes.func,
  onInvalidSubmit: PropTypes.func,
  onReset: PropTypes.func,
  onSubmit: PropTypes.func,
  onValid: PropTypes.func,
  onValidSubmit: PropTypes.func,
  preventDefaultSubmit: PropTypes.bool,
  preventExternalInvalidation: PropTypes.bool,
  reset: PropTypes.func,
  updateInputsWithError: PropTypes.func,
  updateInputsWithValue: PropTypes.func,
  validationErrors: PropTypes.func,
};

export default function FormContainer({ children, innerRef, ...props }) {
  const { handleError } = useAppAlert()

  const handleInvalidFormSubmit = useCallback(() => {
    handleError('Error', 'Some fields were not filled in properly. Please, review all fields.')
  }, [handleError])

  return <Formsy ref={innerRef} onInvalidSubmit={handleInvalidFormSubmit} {...props}>
    {children}
  </Formsy>
}

FormContainer.propTypes = propTypes
FormContainer.defaultProps = {}
